import React from "react";

const Section = ({ title, children }) => (
  <div className="mt-5">
    <p className="font-serif text-lg text-[#5A3A4B] mb-2">{title}</p>
    {children}
  </div>
);

export const TirageFrameNotice = ({ checked, onChange }) => (
  <div className="mt-8 card-soft p-5 sm:p-6 border border-[#C9A56A]/40" data-testid="tirage-frame-notice">
    <h2 className="font-serif text-xl sm:text-2xl text-[#5A3A4B]">✨ Avant de réserver ton tirage intuitif</h2>
    <div className="text-sm text-[#7A5D58] leading-relaxed break-words">
      <p className="mt-3">Pour que cette expérience se déroule dans un cadre clair et respectueux, prends quelques instants pour lire ces informations.</p>
      <Section title="Je ne traite pas les demandes portant sur :">
        <ul className="space-y-2">
          {[
            "La santé, la grossesse ou les questions judiciaires.",
            "Des prédictions exactes : une date précise, le portrait détaillé d’une future rencontre ou une décision professionnelle à prendre à ta place.",
            "L’avenir ou la vie privée d’une autre personne, même s’il s’agit d’un proche ou de tes enfants.",
          ].map((t) => (
            <li key={t} className="flex items-start gap-2"><span className="text-[#C9A56A] mt-0.5 shrink-0">•</span><span>{t}</span></li>
          ))}
        </ul>
        <p className="mt-3">Ton tirage doit rester centré sur toi, ton vécu et tes propres questionnements.</p>
      </Section>
      <Section title="Un éclairage, avec toute ta liberté">
        <p>Lors d’un tirage, je te partage ce que je perçois, sans chercher à obtenir à tout prix une réponse particulière. Des éléments concernant l’avenir peuvent émerger spontanément, mais je ne peux ni les provoquer ni les promettre.</p>
        <p className="mt-3">Tu conserves toujours ton libre arbitre : tes choix t’appartiennent et ton ressenti reste ton premier repère.</p>
      </Section>
      <Section title="Un cadre qui respecte ta situation">
        <p>Je peux refuser une demande si j’estime qu’un tirage n’est pas approprié à ta situation ou à ton état émotionnel ou psychologique du moment. Si tu as déjà réglé la prestation, elle te sera intégralement remboursée.</p>
      </Section>
      <Section title="Une expérience à accueillir avec discernement">
        <p>La médiumnité et les tirages intuitifs ne sont pas des sciences exactes. Je ne peux donc pas garantir l’exactitude de chaque information, ni qu’elle fera forcément écho en toi.</p>
        <p className="mt-3">Je t’invite à vivre ce moment avec ouverture, tout en gardant ton esprit critique et ta liberté d’interprétation.</p>
      </Section>
    </div>
    <label className="mt-6 flex items-start gap-3 rounded-xl border border-[#7A5D58]/15 bg-[#FCFAF7] p-4 text-sm text-[#5A3A4B] cursor-pointer">
      <input type="checkbox" className="w-5 h-5 mt-0.5 accent-[#5A3A4B] shrink-0" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid="gf-frame-ack" />
      <span>J’ai lu et compris le cadre des tirages intuitifs.</span>
    </label>
  </div>
);
